import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  [constructionSelector],
  (construction) => {
    let gateImg = null;

    if (construction.available?.gate?.length > 0) {
      const gateId = construction.selected.gate;
      const gate = construction.available.gate.find((el) => el.id === gateId);
      gateImg = gate?.attributes?.img;
    }

    const selectedWidthId = construction.selected.width;
    const selectedWidthElement = construction.available.width.find(
      (el) => el.id === selectedWidthId
    );
    const width = selectedWidthElement?.attributes?.value_cm || 0;

    const gateCount = construction.gates.count; // wybrana liczba bram
    let normalizedGates = [...(construction.gates.gates || [])];

    // przytnij nadmiar
    if (normalizedGates.length > gateCount) {
      normalizedGates = normalizedGates.slice(0, gateCount);
    }

    // uzupełnij brakujące
    if (normalizedGates.length < gateCount) {
      const missing = gateCount - normalizedGates.length;
      const defaultGate = { type: null, height: 0, width: 0, position: 0 };
      normalizedGates = [
        ...normalizedGates,
        ...Array(missing).fill(defaultGate),
      ];
    }

    return {
      gateImg,
      info: construction.info.gate,
      loaded: construction.parameters_loaded,
      gate_count_available: construction.gates.available_count,
      gate_count_selected: construction.gates.count,
      gate_count_info: construction.info.gate_count,
      width, // aktualny width
      gates: {
        ...construction.gates,
        gates: normalizedGates, // <- zawsze dopasowana długość
      },
      tooling: construction.selected.tooling,
    };
  }
);
